import * as React from "react";
const SvgFiRrPollution = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-pollution_svg__a)">
      <path
        fill="#062147"
        d="M24 8c0 .458-.077.907-.229 1.334a1 1 0 1 1-1.885-.668A2.003 2.003 0 0 0 20.041 6c-.498 0-1.011-.361-1.082-.854A2.5 2.5 0 0 0 16.499 3c-.504 0-.992.151-1.41.438-.403.274-.947.22-1.286-.131a4.2 4.2 0 0 0-3.054-1.308 4.27 4.27 0 0 0-3.835 2.452c-.172.366-.653.645-1.148.552-2.177 0-3.767 1.68-3.767 3.996 0 .856.308 1.669.891 2.35a1 1 0 1 1-1.518 1.3c-.898-1.047-1.373-2.31-1.373-3.65C0 5.694 2.31 3.174 5.424 3.009 6.55 1.162 8.574 0 10.75 0c1.444 0 2.81.488 3.919 1.39A4.5 4.5 0 0 1 16.5 1c1.942 0 3.647 1.274 4.252 3.071A4.01 4.01 0 0 1 24 8M13.756 21.337c.689 1.181-.163 2.663-1.53 2.663H1.773C.406 24-.445 22.517.243 21.337l5.227-8.96c.683-1.171 2.376-1.171 3.059 0zM8 22a1 1 0 1 0-2 0 1 1 0 0 0 2 0m0-6a1 1 0 0 0-2 0v3a1 1 0 0 0 2 0zm10.5-5c-.564 0-1.12.088-1.66.263a6.57 6.57 0 0 0-5.612-1.018 1 1 0 0 0-.69 1.234c.15.53.701.842 1.234.689a4.56 4.56 0 0 1 4.221.979c.295.263.718.327 1.078.165a3.5 3.5 0 0 1 1.43-.313c1.93 0 3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5c-.487 0-.968-.105-1.43-.313a1 1 0 1 0-.823 1.822 5.4 5.4 0 0 0 2.252.491c3.033 0 5.5-2.468 5.5-5.5s-2.467-5.5-5.5-5.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-pollution_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrPollution;
